import { api, unwrap } from './client';

export function recentActivity() {
  return unwrap(api.get('/api/dashboard/activity'));
}
